module.exports = __webpack_public_path__ + "img/callAnimation.e6808482.svg";